import { compressToEncodedURIComponent as e, decompressFromEncodedURIComponent as t } from "lz-string";
//#region src/utils/url.ts
var n = !1;
function r() {
	if (window.top) try {
		return {
			location: window.top.location,
			history: window.top.history
		};
	} catch {
		n ||= (console.debug("Error getting top location. Using window.location"), !0);
	}
	return {
		location: window.location,
		history: window.history
	};
}
var i = (t, n, i = !0) => {
	let { location: a, history: o } = r(), s = new URL(a.href), c = i ? e(n) : n;
	s.searchParams.set(t, c), o.replaceState(null, "", s.href);
}, a = (e, n = !0, i = !0, a) => {
	let { location: o } = r(), s;
	try {
		s = new URL(o.href).searchParams.get(e) || "";
	} catch (e) {
		return console.warn(`Error getting URL parameter: '${e.message}'. No data retrieved`), null;
	}
	let c = i ? t(s) : s;
	try {
		return !c || c === a ? null : n ? JSON.parse(c) : c;
	} catch (e) {
		return console.warn(`Error parsing URL parameter: '${e.message}'. No data retrieved`), null;
	}
}, o = (e) => {
	let { location: t, history: n } = r(), i = new URL(t.href), a = new URLSearchParams(i.search), o = i.toString().split("?")[0];
	for (let t of e) a.delete(t);
	let s = a.toString() ? `?${a.toString()}` : "";
	n.replaceState(null, "", `${o}${s}`);
};
//#endregion
export { i as addParameterToUrl, e as compressToEncodedURIComponent, a as getParameterFromUrl, o as removeParamsFromUrl };
